export default "__VITE_ASSET__oYZzmaui__"